import styled from 'styled-components';
import { CaptionBoldL } from '../../styles/globals';
import { IThemeProvider } from '../../styles/theme';


export const AgreementIndicatorCont = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: max-content;
  justify-content: flex-end;
  svg {
    width: 13.33px;
    height: 13.33px;
    margin: 0 0 0 5px;
  }
`;

export const HighIndicator = styled(CaptionBoldL)`
  width: max-content;
  margin: 0 0 0 71px;
  ${({theme}: IThemeProvider) => `
    color: ${theme.colors.support.green[100]};
  `};
`;

export const ModerateIndicator = styled(CaptionBoldL)`
  width: max-content;
  margin: 0 0 0 39px;
  ${({theme}: IThemeProvider) => `
    color: ${theme.colors.support.blue[100]};
  `};
`;

export const LowIndicator = styled(CaptionBoldL)`
  width: max-content;
  margin: 0 0 0 74px;
  ${({theme}: IThemeProvider) => `
    color: ${theme.colors.accent.violet[100]};
  `};
`;

export const DisagreementIndicator = styled(CaptionBoldL)`
  width: max-content;
  margin: 0 0 0 83px;
  ${({theme}: IThemeProvider) => `
    color: ${theme.colors.support.red[100]};
  `};
`;

